export default __webpack_public_path__ + "static/si-0bae5192ca26652ce5ff055539989f3b.svg";